import { Stack, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

interface BarChartComponentProps {
    data: number[];
    height?: number;
    label?: string;
    labels: string[];
    title: string;
}

function BarChartComponent({ data, height = 280, label = 'Metric', labels, title }: Readonly<BarChartComponentProps>) {
    return (
        <Stack
            sx={{
                flex: 1,
            }}
        >
            <Typography variant="subtitle2">{title}</Typography>
            <BarChart
                height={height}
                series={[{ data, id: 'metric', label: label || undefined }]}
                xAxis={[{ data: labels, scaleType: 'band' }]}
            />
        </Stack>
    );
}

export default BarChartComponent;
